import { useEffect, useState } from 'react';
import { useUser } from '../useUser/useUser';

export const useWelcomeModal = () => {
  const { mood } = useUser();
  const [isWelcomeModalOpen, setIsWelcomeModalOpen] = useState(false);

  const toggleWelcomeModal = () => {
    setIsWelcomeModalOpen(!isWelcomeModalOpen);
  };

  useEffect(() => {
    setIsWelcomeModalOpen(mood?.initMood === 0);
  }, [mood]);

  return {
    toggleWelcomeModal,
    isWelcomeModalOpen,
  };
};
